<template>
  <el-container>
    <el-main
      id="main-layout"
      :class="[getLayoutStyle, { assist_lesson: isAssistLesson }, { discovery_lesson: isDiscoveryLesson }]"
    >
      <el-row>
        <el-col id="video-column" :class="[videoScreenLayout ? 'left_contents' : 'right_contents', isHtmlRevampOrCmsPreview ? 'is_revamp' : '']">
          <el-row>
            <!-- Video Chat Component -->
            <VideoChat ref="videoChat" @reconnect="reRenderVideo" :key="componentKey" />

            <!-- Horizontal Slider -->
            <div @mousedown="adjustVertically" class="slider-horizontal">
              <div class="border"></div>
            </div>

            <!-- Chat Component -->
            <div :class="[videoScreenLayout ? 'right_contents' : '']">
              <Chatbox
                class="chat"
                ref="chatBox"
                :setTagDialogPosition="setTrainerTagDialogPosition"
                :class="{ hide: materialSwitch !== 'chat' }"
              />
            </div>
          </el-row>
        </el-col>
        <el-col class="left_contents left_side" :class="classObject">
          <div class="material">
            <!-- Material Selection Component -->
            <MaterialControls />
            <!-- PDF Material Component -->
            <el-col class="left_text_content" :class="{ fullscreen: isMaterialFullScreen }">
              <MaterialControlsZoom />
              <PDFMaterial v-if="showPdf" />
              <DiscoveryMaterial v-if="isDiscoveryLesson" />
            </el-col>
          </div>
          <!-- Vertical Slider -->
          <div @mousedown="adjustHorizontally" class="slider-vertical">
            <div class="border"></div>
          </div>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
import { layoutStyle, providers } from '@/utils/constants';

import layoutAdjustment from '@/mixins/layoutAdjustment';
import cmsPreview from '@/mixins/cmsPreview';
import VideoChat from '@/components/Lesson/VideoChat';
import Chatbox from '@/components/Lesson/Chatbox';
import PDFMaterial from '@/components/Lesson/Material/PDFMaterial';
import DiscoveryMaterial from '@/components/Lesson/Material/DiscoveryMaterial';
import MaterialControls from '@/components/Lesson/Material/MaterialControls';
import MaterialControlsZoom from '@/components/Lesson/Material/MaterialControlsZoom';

export default {
  mixins: [layoutAdjustment, cmsPreview],
  components: {
    VideoChat,
    Chatbox,
    PDFMaterial,
    DiscoveryMaterial,
    MaterialControls,
    MaterialControlsZoom
  },
  props: ['showPdf'],
  data() {
    return {
      componentKey: 0 // use to rerender componect
    };
  },
  created() {
    if (this.isAssessmentLesson) {
      this.switchLayoutStyle(layoutStyle.default);
    } else if (!this.isAssistLesson) {
      this.switchLayoutStyle(layoutStyle.material);
    }
  },
  mounted() {
    this.setChatHeight();
    window.addEventListener('resize', this.setChatAndVideoSize);
  },
  watch: {
    layoutStyle() {
      this.$nextTick(() => {
        this.setCurrrentLayoutStyle();
        this.resetAdjustedSize();
        this.setChatAndVideoSize();
        this.setTrainerTagDialogPosition();
      });
      this.reAdjustVideo();
    }
  },
  computed: {
    ...mapState('layout', ['layoutStyle', 'materialSwitch', 'isMaterialFullScreen']),
    ...mapState('htmlMaterial', ['htmlIsRevamp']),
    ...mapState(['provider']),
    ...mapState('videoRtc', ['rtcClient']),
    ...mapGetters(['isAssistLesson', 'isAssessmentLesson', 'isDiscoveryLesson']),

    isHtmlRevampOrCmsPreview() {
      return this.htmlIsRevamp || this.isCmsPreview
    },

    classObject() {
      return {
        hide: this.materialSwitch !== 'material',
        fullscreen: this.isMaterialFullScreen,
        is_revamp: !!(this.htmlIsRevamp) || this.isCmsPreview
      };
    },

    // get the current active layout style
    getLayoutStyle() {
      return `content_${this.layoutStyle}`;
    },

    // check if current layout is video/screen streaming
    videoScreenLayout() {
      return this.layoutStyle === layoutStyle.videoScreen;
    }
  },
  methods: {
    ...mapMutations('layout', ['setIsVideoReloading']),
    ...mapMutations('connection', ['setReconnecting']),
    ...mapActions('layout', ['switchLayoutStyle']),
    ...mapMutations('videoRtc', ['setIsShareScreenOn']),

    reRenderVideo: function() {
      this.$logger.info('Reconnect video', { operation: 'webrtc:reconnect' });
      this.setIsVideoReloading(true);
      this.setReconnecting(true);
      if (this.rtcClient && this.provider == providers.agora) {
        this.$logger.info('Disconnect from ' + this.provider, { operation: 'webrtc:reconnect' });
        this.rtcClient.disconnect();
      }

      // force render VideoChat commonent to reconnect webrtc provider
      this.componentKey++;
      // reapply the adjusted size on video/chat
      this.reapplyVideoChatSize();
      // reset screen share
      this.setIsShareScreenOn(false);
    }
  },
  beforeDestroy: function() {
    window.removeEventListener('resize', this.setChatAndVideoSize);
  }
};
</script>
